import React from "react";
import { Dropdown as PrimeReactDropdown } from "primereact/dropdown";
import classes from "./Dropdown.module.css";
import PropTypes from "prop-types";
import { IconName } from "react-icons"; // Replace with your desired icon library
import clsx from "clsx";
const Dropdown = ({
  value,
  onChange,
  options,
  placeholder,
  className,
  errorText,
  disabled,
  id,
  label,
  isOptional,
  icon, // New prop for the icon
  tooltip,
  showTooltip = false,
  optionLabel="label",
  optionValue="value",
  ...rest
}) => {
  // Custom template for the selected value with an icon
  const itemTemplate = (option) => (
    <div className={classes.optionItem}>
      {option.icon ? (
        <span className={classes.optionIcon}>{option.icon}</span>
      ) : null}
      <span className={classes.truncateText}>{option.label}</span>
    </div>
  );

  const selectedValueTemplate = (option) => {
    return (
      <div className={classes.valueWithIcon}>
        {icon && <span className={classes.icon}>{icon}</span>}
        <span 
          className={classes.truncateText} 
          style={option ? { color: 'var(--text-color)' } : { color: 'var(--placeholder-color)' }}
        >
          {option ? option.label : placeholder}
        </span>
      </div>
    );
  };

  return (
    <>
      <style jsx>
        {`
          .p-dropdown {
            // width: 150px !important; /* Set a fixed width */
          }

          .p-dropdown-item {
            outline: 0 !important;
          }
        `}
      </style>

      <div className={classes.dropdownWrapper}>
        {label && (
          <label htmlFor={id} className={classes.labelText}>
            {label} {"   "}{" "}
            {!isOptional && <span className={clsx("steric")}>*</span>}
          </label>
        )}
        {showTooltip && tooltip && (
          <div className="tooltip" title={tooltip}>
            <PrimeReactDropdown
              filter={true}
              id={id}
              value={value}
              onChange={(e) => {
                console.log("e ==> <==", e);
                onChange(e?.target?.value)
              }}
              options={[...options]}
              placeholder={placeholder}
              className={`${classes.customDropdown} ${errorText ? classes.error : ""} ${
                className || ""
              }`}
              filterBy={optionLabel}
              appendTo="self"
              disabled={disabled}
              valueTemplate={selectedValueTemplate}
              filterInputAutoFocus
              itemTemplate={itemTemplate}
              optionLabel="locationName"
              optionValue="locationID"
              {...rest}
            />
          </div>
        )}
        {!showTooltip && (
          <PrimeReactDropdown
            filter={true}
            id={id}
            value={value}
            onChange={(e) => {
              onChange(e?.target?.value)
            }}
            options={[...options]}
            placeholder={placeholder}
            className={`${classes.customDropdown} ${errorText ? classes.error : ""} ${
              className || ""
            }`}
            filterBy="label"
            appendTo="self"
            disabled={disabled}
            valueTemplate={selectedValueTemplate}
            filterInputAutoFocus
            itemTemplate={itemTemplate}
            {...rest}
          />
        )}
       
        {errorText && <p className={"errorText"}>{errorText}</p>}
      </div>
    </>
  );
};

Dropdown.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  errorText: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.node, // New prop for the icon
  tooltip: PropTypes.string,
  showTooltip: PropTypes.bool,
};

export default Dropdown;
